<template>
<div>

  <div id="kpxxEdit" v-if="editFlag">
    <div id="kpxxView" class="pt15">
        <el-form class="el-form demo-form-inline" ref="kpxxForm" :model="kpxxForm" label-position="right" label-width="250px" :rules="kpxxRules">
          <el-row class="tr mb5">
            <el-col :span="5">&nbsp;</el-col>
            <el-col :span="12">
              <el-form-item prop="kpgsmc" label="Company Name on the Invoice">
                <el-input size="small" v-model="kpxxForm.kpgsmc" placeholder="Company Name on the Invoice"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="5">&nbsp;</el-col>
            <el-col :span="12">
              <!--公司地址字段存英文联系人-->
              <el-form-item prop="gsdz" label="Customer Contact">
                <el-input size="small" v-model="kpxxForm.gsdz" placeholder="Customer Contact"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="5">&nbsp;</el-col>
            <el-col :span="12">
              <!--电话号码字段存英文联系人电话-->
              <el-form-item prop="dhhm" label="Phone Number">
                <el-input size="small" v-model="kpxxForm.dhhm" placeholder="Phone Number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">&nbsp;</el-col>
          </el-row>
          <el-row class="tr mb5">
            <el-col :span="5">&nbsp;</el-col>
            <el-col :span="12">
              <!--银行账号字段存英文传真-->
              <el-form-item prop="yhzh" label="Fax">
                <el-input size="small" v-model="kpxxForm.yhzh" placeholder="Fax"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">&nbsp;</el-col>
          </el-row>
          <el-row class="buttonSubmit">
            <el-col :span="24">
              <el-button v-if="kpxxData.validateFlag=='T'" type="info" icon="el-icon-close" size="small" class="btn_submit" @click="cancel()">Cancel</el-button>
              <el-button type="success" icon="el-icon-check" size="small" class="btn_submit" @click="submitKpxx('kpxxForm')">Save</el-button>
            </el-col>
          </el-row>
        </el-form>
    </div>
  </div>

  <div class="main-container" element-loading-text="加载中" v-if="!editFlag">
    <div id="qykpxx" class="mb5">
      <el-row>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="21">
            <el-row class="mb10">
              <strong>Company Name on the Invoice：</strong>
              <span v-text="kpxxData.kpgsmc||'no'"></span>
            </el-row>
            <el-row class="mb10">
              <strong>Customer Contact：</strong>
              <span v-text="kpxxData.gsdz||'no'"></span>
            </el-row>
            <el-row class="mb10">
              <el-col :span="12">
                <strong>Fax：</strong>
                <span v-text="kpxxData.yhzh||'no'"></span>
              </el-col>
              <el-col :span="12">
                <strong>Phone Number：</strong>
                <span v-text="kpxxData.dhhm||'no'"></span>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="2">
              <el-button type="primary" icon="el-icon-edit" size="small" class="btn_submit" @click="editClick()">Edit</el-button>
            </el-col>
        </el-row>
    </div>
  </div>
</div>

</template>

<script>
export default {
  props:{
    qyid: {
        type: String,
        required: true
    },
    baseInforForm: {
      type: Object,
      required: true
    }
  },
  
  name: "kpxxEdit",
  data() {
    return {
      //当前用户
      currentUser: this.CONSTANT.currentUser,
      //开票信息表单
      kpxxForm: {
        kpgsmc: "",
        gsdz: "",
        dhhm: "",
        yhzh: ""

      },
      kpxxRules: {
        kpgsmc: [
          {
            required: true,
            message: "Company Name on the Invoice is required",
            trigger: "blur"
          },
          // { pattern: /^[A-Za-z0-9 ]+$/, message: 'Characters and number and blank only',trigger: 'blur' },
          /*
          {
            pattern: /^[\da-zA-Z \!\?\r\n\|\<\>\.\,\，\;\:\'\"\@\#\$\￥\=\+\_\—\%\^\&\*\(\)\（\）\[\]\{\}\\\/\~\`\-\。\·\…\！\、\“\”\‘\’\《\》\<\>\【\】\：\；\？]*$/,
            message: "Characters and number only",
            trigger: "blur"
          },*/
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          {
            min: 1,
            max: 200,
            message: "Less than 200 characters",
            trigger: "blur"
          }
        ],
        gsdz: [
          {
            required: true,
            message: "Customer Contact is required",
            trigger: "blur"
          },
          /*
          {
            pattern: /^[\da-zA-Z \!\?\r\n\|\<\>\.\,\，\;\:\'\"\@\#\$\￥\=\+\_\—\%\^\&\*\(\)\（\）\[\]\{\}\\\/\~\`\-\。\·\…\！\、\“\”\‘\’\《\》\<\>\【\】\：\；\？]*$/,
            message: "Characters and number only",
            trigger: "blur"
          },*/
          { validator: (rule, value, callback) => {
            if (value) {
              if (/[\u4E00-\u9FA5]/g.test(value)) {
                callback(new Error('Include Chinese characters'));
              } else {
                callback();
              }
            }
            callback();
            }, trigger: 'blur' },
          // { pattern: /^[A-Za-z0-9 ]+$/, message: 'Characters and number and blank only',trigger: 'blur' },
          {
            min: 1,
            max: 300,
            message: "Less than 300 characters",
            trigger: "blur"
          }
        ],
        dhhm: [
          {
            required: true,
            message: "Phone Number is required",
            trigger: "blur"
          },
          //{pattern: /^[\d\-]+$/, message: "Number and hyphen only",trigger: "blur"},
          {
            min: 1,
            max: 30,
            message: "Less than 30 characters",
            trigger: "blur"
          }
        ],
        yhzh: [
          { required: true, message: "Fax is required", trigger: "blur" },
        //  { pattern: /^[0-9 ]*$/, message: "Number and blank only", trigger: "blur" },
          {
            min: 1,
            max: 16,
            message: "Less than 16 characters",
            trigger: "blur"
          }
        ]
      },

      editFlag: false,
      //企业开票信息
      kpxxData: {},
    };
  },
  watch: {
    qyid(){
      if(this.qyid == 'newInsert'){
        this.editFlag = true;
      }else if(this.qyid != ''){
        this.findKpxxByQyid(this.qyid);
      }
    }
  },
  created: function() {

  },
  methods: {
    //通过企业id查找开票信息
    findKpxxByQyid: function(qyid) {
      let vm = this;
      vm.$emit("getLoading", true);
      var params = {
        qyid: qyid,
        deleteFlag: "N"
      };
      vm.$axios.post("/qykpxx/list", params).then(
        function(res) {
          if (res.data.result.length > 0) {
            vm.kpxxData = JSON.parse(JSON.stringify(res.data.result[0]));

            vm.kpxxForm = res.data.result[0];
            if(res.data.result[0].validateFlag == 'T'){
                vm.editFlag = false;
              }else{
                vm.editFlag = true;
              }
          } else {
            vm.kpxxForm= {
              uuid:"",
              kpgsmc: "",
              gsdz: "",
              dhhm: "",
              yhzh: ""
            };
            // //开票公司名称：必填，把企业基本信息中的“英文公司名称“带到文本框中，文本框可修改
            vm.kpxxForm.kpgsmc = vm.baseInforForm.ywgsmc;
            //是否与上面填的联系人一致，否则需要填写
            vm.kpxxForm.gsdz = vm.baseInforForm.lxr;
            //与上面填的联系人电话一致，否则需要填写
            vm.kpxxForm.dhhm = vm.baseInforForm.lxrsj;
            //与上面填的传真一致，否则需要填写
            vm.kpxxForm.yhzh = vm.baseInforForm.cz;
            vm.editFlag = true;
            
          }
          vm.$emit("getLoading", false);
        }.bind(vm),
        function(error) {
          vm.$emit("getLoading", false);
          console.log(error);
        }
      );
    },
  
    //开票信息提交（下一步）
    submitKpxx: function(formName) {
      let vm = this;
      if (vm.qyid == 'newInsert') {
        vm.$alert("Failed to save. Please fill in the Brief Information before filling in other information", 'Info', {
          confirmButtonText: 'ok'
        });
      }else{
        vm.$refs[formName].validate(valid => {
        if (valid) {
          vm.$emit("getLoading", true);
          var params = {
              uuid: vm.kpxxForm.uuid,
              qyid: vm.qyid,
              kpgsmc: vm.kpxxForm.kpgsmc,
              gsdz: vm.kpxxForm.gsdz,
              dhhm: vm.kpxxForm.dhhm,
              yhzh: vm.kpxxForm.yhzh,
              deleteFlag: "N",
              xgrid: vm.currentUser.userid,
              xgrmc: vm.currentUser.username,
              validateFlag: 'T'
            };
            vm.$axios.post("/qykpxx/doInsertOrUpdateKpxxByVO",params).then(
              function(res) {
                if (res.data.result != null && res.data.result != "") {
                  vm.$message({
                    message: "Invoice Information has been saved!",
                    type: "success"
                  });
                  vm.$emit("getLoading", false);
                  //this.$emit("getActive",  2);

                  vm.editFlag = false;
                  this.findKpxxByQyid(this.qyid);
                } else {
                  vm.$message({
                    message: "Invoice Information save failed!",
                    type: "error"
                  });
                  vm.$emit("getLoading", false);
                }
              }.bind(vm),
                    function(error) {
                      console.log(error);
                    }
            );
        } else {
          setTimeout(() => {
              var isError = document.getElementsByClassName("is-error");
              isError[0].querySelector('input,textarea').focus();
            }, 100);
          console.log("error submit!!");
          return false;
        }
      });
      }
    },

    editClick: function(){
      this.editFlag = true;
    },
    cancel: function(){
      this.findKpxxByQyid(this.qyid);
    }
  }
};
</script>

<style lang="scss">
#kpxxEdit {
  .mb5 {
    margin-bottom: 5px;
  }
  
  .el-card__body {
    padding: 10px 0px 10px 0px;
  }
  .el-message {
    z-index: 10005 !important;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }
  .el-dialog {
    width: 45%;
  }
  .el-button--small {
    padding: 9px 9px;
  }

  .card_title_font{
    line-height: 40px;
  }
  .clearfix{
    height: 40px;
  }
  
}
</style>



// WEBPACK FOOTER //
// src/views/exhibition/prediction/exhprediction/exhpredictionEditEng/Kpxx.vue